import findReactFiber from './find-react-fiber';
export default function findFiberWithCache(element, maxLevel, checkedNodes) {
  // Stop when no more levels to traverse
  if (maxLevel <= 0) {
    return null;
  }
  checkedNodes.push(element);
  var fiber = findReactFiber(element);
  if (fiber) {
    return fiber;
  }

  // Walk up the DOM tree to find the fiber
  var parent = element.parentElement;
  if (!parent) {
    return null;
  }

  // Recursively check parent
  return findFiberWithCache(parent, maxLevel - 1, checkedNodes);
}